import { render, staticRenderFns } from "./UiPrintTickets.vue?vue&type=template&id=919cdd9e&lang=pug&"
import script from "./UiPrintTickets.vue?vue&type=script&lang=js&"
export * from "./UiPrintTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports